import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GridListComponent } from './grid-list.component';
import { BrMaskerModule } from 'br-mask';
import { CalendarioComponentModule } from '../calendario/calendario.component.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    GridListComponent
  ],
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrMaskerModule,
    CalendarioComponentModule
  ],
  exports: [
    GridListComponent
  ],
  entryComponents: [
    GridListComponent
  ]
})
export class GridListComponentModule { }
